module.exports = __webpack_public_path__ + "img/creditCardQRRe.0a855cc7.svg";